module.exports = __webpack_public_path__ + "sg.8a467f1a0649fb27c2d6.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/sg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/sg.svg
// module chunks = styles